import { create } from '@bufbuild/protobuf';

import * as pbm from '@/grpc-gen/reservation_service_pb';

export default class ReservationServiceTranslation {
  id: number = 0;

  locale: string = '';

  title: string = '';

  description: string = '';

  imageUrl: string = '';

  tags: string[] = ['', '', ''];

  static fromGrpcModel(o?: pbm.ReservationServiceTranslation): ReservationServiceTranslation {
    const s = new ReservationServiceTranslation();

    s.locale = o?.locale ?? '';
    s.title = o?.title ?? '';
    s.description = o?.description ?? '';
    s.tags = o?.tags ?? [];
    s.imageUrl = o?.imageUrl ?? '';

    while (s.tags.length < 3) s.tags.push('');

    return s;
  }

  toGrpcModel(): pbm.ReservationServiceTranslation {
    return create(pbm.ReservationServiceTranslationSchema, {
      locale: this.locale ?? '',
      title: this.title ?? '',
      description: this.description ?? '',
      imageUrl: this.imageUrl ?? '',
      tags: this.tags ?? [],
    });
  }

  clone(): ReservationServiceTranslation {
    const copy = new ReservationServiceTranslation();
    Object.assign(copy, this);
    copy.tags = Array.from(this.tags);
    while (copy.tags.length < 3) copy.tags.push('');
    return copy;
  }
}
